module.exports = __webpack_public_path__ + "img/123.5.a1c21e95.png";